//Include Both Helper File with needed methods

import {
  
    getHomeTradeConfirmMonths,
    
} from "../../../helpers/fakebackend_helper";



import { createAsyncThunk } from "@reduxjs/toolkit";


export const home_tradeConfirmationMonthsThunk = createAsyncThunk("home_tradeConfirmationMonthsThunk", async ({  token }, { rejectWithValue } ) => {
  try {
    const response = await getHomeTradeConfirmMonths(  token);
    return response;
  } catch (error) {
    // Properly pass the error structure to the reducer
    return rejectWithValue({
      code: error.data?.code || error.code,
      message: error.message,
      data: error.data
    });
  }
});










